import { extend, $$, addEvent, $, hasParentsClass } from './helper-functions'

export class MainNavigation {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.main-navigation',
      linksWithSubtree: '.main-navigation button[aria-haspopup]',
      activeLinks: '.main-navigation--active',
      back: '.main-navigation__back',
      page: '.page'
    }, selectors)

    this.classes = extend({
      block: 'main-navigation',
      active: 'main-navigation--active',
      buttonClose: 'main-navigation__close',
      pageBlur: 'page--blur-content-footer'
    }, classes)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    const linksWithSubtree = $$(this.selectors.linksWithSubtree)
    linksWithSubtree.forEach((linkWithSubtree) => {
      addEvent(linkWithSubtree, 'click', (event) => {
        event.preventDefault()

        $$(this.selectors.activeLinks).forEach((activeLink) => {
          if (activeLink !== linkWithSubtree) {
            activeLink.classList.remove(this.classes.active)
          }
        })

        linkWithSubtree.classList.toggle(this.classes.active)
        linkWithSubtree.setAttribute('aria-expanded', !!linkWithSubtree.classList.contains(this.classes.active))

        window.setTimeout(() => {
          if (window.innerWidth > 1343) {
            $(this.selectors.page).classList.toggle(this.classes.pageBlur, linkWithSubtree.classList.contains(this.classes.active))
          }
        }, 100)
      })
    })

    addEvent($('body'), 'click', (event) => {
      const activeLinks = $$(this.selectors.activeLinks)
      if ((!hasParentsClass(event.target, this.classes.block) || hasParentsClass(event.target, this.classes.buttonClose)) && activeLinks.length > 0) {
        activeLinks.forEach((activeLink) => {
          activeLink.classList.remove(this.classes.active)
          activeLink.setAttribute('aria-expanded', !!activeLink.classList.contains(this.classes.active))
        })

        $(this.selectors.page).classList.remove(this.classes.pageBlur)
      }
    })

    $$(this.selectors.back).forEach((backButton) => {
      addEvent(backButton, 'click', (event) => {
        $$(this.selectors.activeLinks).forEach((activeLink) => {
          activeLink.classList.remove(this.classes.active)
          activeLink.setAttribute('aria-expanded', !!activeLink.classList.contains(this.classes.active))
        })
      })
    })

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        $$(this.selectors.activeLinks).forEach((activeLink) => {
          activeLink.classList.remove(this.classes.active)
          activeLink.setAttribute('aria-expanded', !!activeLink.classList.contains(this.classes.active))
        })
      }
    })
  }
}

export default MainNavigation
